import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import {
  Container,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import ServiceCategoriesTable from "./ServiceCategoriesTable"
import "../../../../assets/scss/custom.scss"

const EcommerceCategories = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Categories | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Service" breadcrumbItem="Categories" />
              <ServiceCategoriesTable
                queryCondition={null}
                activeFilters={["category", "created_at"]}
                filterQueryConditions={null}
                showCreateBtn={true}
              />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}
EcommerceCategories.propTypes = {}
export default withRouter(EcommerceCategories)
